import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { FormulaService } from '../../services/formula/formula.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FormulaDetailResolve implements Resolve<any> {

    constructor(private fs: FormulaService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let id = +route.params['id'];

        return this.fs.getFormula(id).pipe(map(formula => formula)).pipe(first());
    }

}
